import React, { useState, memo } from 'react';
import DashboardLayout from '../../components/DashboardLayout/DashboardLayout';
import API from '../../utils/API';
import formatLink from '../../utils/formatLink';
import { useSelector, useDispatch } from 'react-redux';
import { saveOrg } from '../../redux/actions';
import './managestore-page.css';
import { Modal } from 'react-bootstrap';
import { BrowserView, MobileView } from 'react-device-detect';
import MobileTopBar from '../../components/common/MobileTopBar';

const HeaderBlock: React.FC<{ reduxOrg: any }> = ({ reduxOrg }) => (
  <>
    <h1 className="manage-store-page-h1">Store</h1>
    <p className="store-hint">{reduxOrg?.actionItems?.marketplace}</p>
  </>
);

type FormProps = {
  reduxOrg: any;
  input: { marketplace?: string };
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (e?: any) => void;
  submitting: boolean;
};

const FormAndCopy: React.FC<FormProps> = memo(
  ({ reduxOrg, input, handleChange, handleSubmit, submitting }) => (
    <div className="store-two-col">
      <div className="store-left">
        <label htmlFor="marketplace" className="form-label">
          Store Link
        </label>
        <input
          id="marketplace"
          type="text"
          name="marketplace"
          placeholder="Paste your Store link here"
          onChange={handleChange}
          value={input.marketplace || ''}
          required
          className="store-input"
        />
        <button
          type="button"
          className="store-submit"
          onClick={handleSubmit}
          disabled={submitting}
        >
          {submitting ? 'Submitting…' : 'Submit'}
        </button>
      </div>
      <div className="store-right">
        <h3>What’s the Store For?</h3>
        <p>
          At NEDDIE, nonprofits can upload a link to their online store. Our Store feature helps organizations
          promote their products and generate extra support through sales, making it easier for donors to shop with purpose.
        </p>
      </div>
    </div>
  )
);

FormAndCopy.displayName = 'FormAndCopy';

const ManageStorePage = () => {
  const reduxOrg = useSelector((state: any) => state.org);
  const [input, setInput] = useState({ _id: reduxOrg._id, marketplace: '' });
  const [submitting, setSubmitting] = useState(false);
  const [showStoreSubmitModal, setShowStoreSubmitModal] = useState(false);
  const dispatch = useDispatch();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event?: any) => {
    event?.preventDefault();
    if (submitting) return;
    setSubmitting(true);

    const payload = { ...input, marketplace: formatLink(input.marketplace) };
    try {
      const response: any = await API.saveMarketplace(payload);
      if (response?.status === 200) {
        dispatch(
          saveOrg({
            ...reduxOrg,
            actionItems: { ...reduxOrg.actionItems, marketplace: payload.marketplace },
          })
        );
        setShowStoreSubmitModal(true)
        setInput({ ...input, marketplace: payload.marketplace }); // keep input in sync
      }
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
    <BrowserView style={{ height: '100%' }}>
    <DashboardLayout>
      <div className="managestore-container">
        <div className="manage-store-wrap">
          <HeaderBlock reduxOrg={reduxOrg} />
          <FormAndCopy
            reduxOrg={reduxOrg}
            input={input}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            submitting={submitting}
          />
        </div>
      </div>
    </DashboardLayout>
    </BrowserView>
    <MobileView>
        <MobileTopBar />
<div className="managestore-mobile-container">
        <div className="manage-store-wrap">
          <HeaderBlock reduxOrg={reduxOrg} />
          <FormAndCopy
            reduxOrg={reduxOrg}
            input={input}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            submitting={submitting}
          />
        </div>
      </div>
    </MobileView>
      <Modal
        show={showStoreSubmitModal}
        onHide={() => setShowStoreSubmitModal(false)}
        size="sm"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p style={{ fontSize: '16px', color: 'green' }}>
              Store link saved successfully!
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ManageStorePage;
